<template>
<div class="smart-container">
    <div class="profile-card">
        <div class="content-inner">

            <!-- ========= 1. 用户信息模块 (手机号为主，移除账号ID和邮箱) ========= -->
            <div class="user-info-area">
                <div class="user-main">
                  <div class="user_left">
                    <div class="avatar-wrapper">
                        <div class="avatar-icon">
                            <!-- <i class="fas fa-user-astronaut"></i> -->
                        </div>
                        <div class="user-info-details">
                          <div class="phone">
                            <div class="user-phone">
                                +86 139 6821 4735
                            </div>
                            <div class="user-name-line" style="margin-bottom: 4px;">
                                <span class="role-badge"><i class="fas fa-certificate"></i> 智能科技 · 专业版</span>
                            </div>
                          </div>


                          <div class="member-since">
                              <i class="far fa-calendar-check"></i> 注册时间: 2025-03-18  ·  上次登录: 2026-06-01
                          </div>
                        </div>
                    </div>

                  </div>
                  <div class="user_right">
                        <!-- 移除账号ID和邮箱，仅保留双重验证状态 -->
                        <div class="user-meta-grid">
                            <span class="meta-item"><i class="fas fa-shield-alt"></i> 双重验证已开启</span>
                            <span class="meta-item"><i class="fas fa-globe"></i> 运营商业务 · 高级权限</span>
                        </div>
                  </div>
                </div>
            </div>
            <div class="content">
                            <!-- ========= 3. 帮助指引模块 (保留原有的帮助入口，标题微调与运营商相关) ========= -->
              <div class="section">
                  <div class="section-header">
                      <i class="fas fa-life-ring"></i>
                      <h3>帮助指引</h3>
                      <span class="section-sub">运营商业务支持</span>
                  </div>
                  <div class="help-grid">
                      <div class="help-card">
                          <i class="fas fa-book-open"></i>
                          <h4>运营手册</h4>
                          <div class="help-desc">运营商对接指南、AI服务接入</div>
                      </div>
                      <div class="help-card">
                          <i class="fas fa-question-circle"></i>
                          <h4>常见问题</h4>
                          <div class="help-desc">计费、配额、API调用解答</div>
                      </div>
                      <div class="help-card">
                          <i class="fas fa-comments"></i>
                          <h4>运营商社区</h4>
                          <div class="help-desc">经验交流 & 最佳实践</div>
                      </div>
                      <div class="help-card">
                          <i class="fas fa-headset"></i>
                          <h4>专属客服</h4>
                          <div class="help-desc">7×24h 运营商专线</div>
                      </div>
                  </div>
                  <div class="help-footer">
                      <i class="fas fa-message"></i> 运营商支持中心: operator.ai-tech.com  ·  工单系统实时响应
                  </div>
              </div>
            <!-- ========= 2. 平台公告模块 (内容全部更新为运营商/运营商AI相关，时间倒序) ========= -->
              <div class="section box2">
                  <div class="section-header">
                      <i class="fas fa-bullhorn"></i>
                      <h3>平台公告</h3>
                      <span class="section-sub">运营商动态 · AI新能力</span>
                  </div>
                  <div class="info-box">
                      <div class="announcement-list">
                          <!-- 最新公告：2026-06-01 -->
                          <div class="announce-item">
                              <div class="announce-icon"><i class="fas fa-chart-line"></i></div>
                              <div class="announce-content">
                                  <div class="announce-title">运营商AI智能服务全新升级：大模型驱动多语言对话，东南亚地区率先商用</div>
                                  <div class="announce-date"><i class="far fa-calendar-alt"></i> 2026-06-01</div>
                              </div>
                          </div>
                          <!-- 公告2：2026-05-28 -->
                          <div class="announce-item">
                              <div class="announce-icon"><i class="fas fa-robot"></i></div>
                              <div class="announce-content">
                                  <div class="announce-title">AI智能体实现全流程闭环：套餐推荐→订单核验仅需90秒，线下机器人同步上线</div>
                                  <div class="announce-date"><i class="far fa-calendar-alt"></i> 2026-05-28</div>
                              </div>
                          </div>
                          <!-- 公告3：2026-05-20 -->
                          <div class="announce-item">
                              <div class="announce-icon"><i class="fas fa-chart-pie"></i></div>
                              <div class="announce-content">
                                  <div class="announce-title">运营商数据洞察平台升级：支持多维实时分析，助力精细化运营决策</div>
                                  <div class="announce-date"><i class="far fa-calendar-alt"></i> 2026-05-20</div>
                              </div>
                          </div>
                          <!-- 公告4：2026-05-15 -->
                          <div class="announce-item">
                              <div class="announce-icon"><i class="fas fa-shield-alt"></i></div>
                              <div class="announce-content">
                                  <div class="announce-title">智能运维保障上线：7×24小时可观测性 + 故障自动预警，保障海外业务连续稳定</div>
                                  <div class="announce-date"><i class="far fa-calendar-alt"></i> 2026-05-15</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>


            </div>
        </div>
    </div>
</div>
</template>

<style lang="scss" scoped>
.smart-container {
            // max-width: 880px;
            width: 1400px;
            margin: 0 auto;
            margin: 36px auto;
        }

        .profile-card {
            background: #ffffff;
            border-radius: 2rem;
            box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0,0,0,0.02);
            overflow: hidden;
            border: 1px solid rgba(66, 153, 225, 0.18);
        }

        .content-inner {
            padding: 36px;
        }

        @media (max-width: 640px) {
            body {
                padding: 1rem;
            }
            .content-inner {
                padding: 1.5rem;
            }
        }

        .section {
          width: 58%;
          margin-bottom: 2rem;
        }
        .section-header {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 1rem;
            // border-left: 4px solid #00C9FF;
            padding-left: 12px;
        }
        .section-header i {
            font-size: 1.3rem;
            color: #00C9FF;
        }
        .section-header h3 {
            font-size: 1.2rem;
            font-weight: 600;
            color: #0b2b3b;
            letter-spacing: -0.2px;
        }
        .section-sub {
            font-size: 0.7rem;
            color: #7c8ea0;
            // margin-left: 12px;
        }

        .info-box {
            background: #fafcff;
            border-radius: 1.25rem;
            border: 1px solid #eef2f8;
            padding: 1.2rem 1.5rem;
        }

        /* 用户信息模块 */
        .user-info-area {
            background: url('@/assets/profile.png')no-repeat center center;
            background-size: cover;
            border-radius: 36px;
            padding: 1.5rem;
            margin-bottom: 2rem;
            box-shadow: 0 6px 14px rgba(0, 0, 0, 0.02);
            border: 1px solid #eef2ff;
        }
        .user-main {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1.5rem;
            flex-wrap: wrap;
        }
        .avatar-wrapper {
            flex-shrink: 0;
            display: flex;
        }
        .avatar-icon {
            width: 84px;
            height: 84px;
            background: url('@/assets/profileLogo.png')no-repeat center center;
            background-size: cover;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 12px 18px -6px rgba(37, 99, 235, 0.3);
            border: 3px solid white;
        }
        .user-info-details {
            flex: 1;
            margin-left: 36px;
        }
        .user-phone {
            font-size: 1.7rem;
            font-weight: 700;
            background: linear-gradient(135deg, #0f2b3d, #1f4e7a);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            letter-spacing: -0.3px;
            margin-bottom: 8px;
        }
        .role-badge {
            background: #eef4ff;
            border-radius: 30px;
            padding: 4px 12px;
            font-size: 0.7rem;
            font-weight: 600;
            color: #00C9FF;
            display: inline-flex;
            align-items: center;
            gap: 6px;
        }
        .user-meta-grid {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            margin-top: 10px;
            font-size: 0.85rem;
            color: #2c4e6e;
        }
        .meta-item {
            background: #f1f5f9;
            border-radius: 40px;
            padding: 4px 14px;
            display: inline-flex;
            align-items: center;
            gap: 8px;
        }
        .meta-item i {
            width: 20px;
            color: #00C9FF;
        }
        .member-since {
            background: #f8fafc;
            border-radius: 30px;
            padding: 6px;
            // margin-top: 12px;
            font-size: 0.75rem;
            color: #4b6589;
            display: inline-block;
        }

        /* 平台公告列表（运营商/运营商AI相关内容） */
        .announcement-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .announce-item {
            display: flex;
            gap: 12px;
            padding: 0.6rem 0;
            border-bottom: 1px solid #f0f4fa;
        }
        .announce-item:last-child {
            border-bottom: none;
        }
        .announce-icon {
            width: 32px;
            height: 32px;
            background: #eef2ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #00C9FF;
            font-size: 0.9rem;
            flex-shrink: 0;
        }
        .announce-content {
            flex: 1;
        }
        .announce-title {
            font-weight: 600;
            font-size: 0.9rem;
            color: #1a3048;
            margin-bottom: 4px;
        }
        .announce-date {
            font-size: 0.7rem;
            color: #7f8ea3;
            display: flex;
            align-items: center;
            gap: 5px;
        }

        /* 帮助指引模块 */
        .help-grid {
            display:flex;
            flex-wrap: wrap;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 1rem;
        }
        .help-card {
            width:48%;
            background: #EEF6FF;
            border: 1px solid #eef3fc;
            border-radius: 1.2rem;
            padding: 24px 0.8rem;
            text-align: center;
        }
        .help-card i {
            font-size: 1.8rem;
            color: #00C9FF;
            // margin-bottom: 8px;
            display: inline-block;
        }
        .help-card h4 {
            // font-size: 0.9rem;
            font-weight: 600;
            margin-bottom: 4px;
            color: #0f2b3b;
        }
        .help-desc {
            font-size: 0.7rem;
            color: #6c7c94;
        }
        .help-footer {
            margin-top: 48px;
            background: #F4F9FE;
            border-radius: 60px;
            padding: 8px 16px;
            font-size: 0.75rem;
            text-align: center;
            color: #2c6280;
        }

        .footer-note {
            text-align: center;
            margin-top: 1.8rem;
            font-size: 0.65rem;
            color: #a0bbd6;
            border-top: 1px solid #eef2fa;
            padding-top: 1.2rem;
        }

        a, button {
            cursor: default;
        }
        .content {
          display: flex;
          justify-content: space-between;
        }
        .phone {
          display: flex;
          align-items: center;
        }
        .user-name-line {
          margin-left: 24px;
        }
        .box2{
          width: 40%;
        }
</style>
